// extracted by mini-css-extract-plugin
export var parcelRow = "_uo-0";